// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanToReactivate } from './IPlanToReactivate';
import {
    IPlanToReactivateFromJSON,
    IPlanToReactivateFromJSONTyped,
    IPlanToReactivateToJSON,
    IPlanToReactivateToJSONTyped,
} from './IPlanToReactivate';

/**
 * 
 * @export
 * @interface IOrganizationReactivationRequest
 */
export interface IOrganizationReactivationRequest {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationReactivationRequest
     */
    payroll_contribution_account_id: number;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationReactivationRequest
     */
    funding_replenishment_account_id: number;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationReactivationRequest
     */
    is_re_card_needed: boolean;
    /**
     * 
     * @type {Array<IPlanToReactivate>}
     * @memberof IOrganizationReactivationRequest
     */
    plans_to_reactivate?: Array<IPlanToReactivate>;
}

/**
 * Check if a given object implements the IOrganizationReactivationRequest interface.
 */
export function instanceOfIOrganizationReactivationRequest(value: object): value is IOrganizationReactivationRequest {
    if (!('payroll_contribution_account_id' in value) || value['payroll_contribution_account_id'] === undefined) return false;
    if (!('funding_replenishment_account_id' in value) || value['funding_replenishment_account_id'] === undefined) return false;
    if (!('is_re_card_needed' in value) || value['is_re_card_needed'] === undefined) return false;
    return true;
}

export function IOrganizationReactivationRequestFromJSON(json: any): IOrganizationReactivationRequest {
    return IOrganizationReactivationRequestFromJSONTyped(json, false);
}

export function IOrganizationReactivationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationReactivationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'payroll_contribution_account_id': json['payroll_contribution_account_id'],
        'funding_replenishment_account_id': json['funding_replenishment_account_id'],
        'is_re_card_needed': json['is_re_card_needed'],
        'plans_to_reactivate': json['plans_to_reactivate'] == null ? undefined : ((json['plans_to_reactivate'] as Array<any>).map(IPlanToReactivateFromJSON)),
    };
}

export function IOrganizationReactivationRequestToJSON(json: any): IOrganizationReactivationRequest {
    return IOrganizationReactivationRequestToJSONTyped(json, false);
}

export function IOrganizationReactivationRequestToJSONTyped(value?: IOrganizationReactivationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payroll_contribution_account_id': value['payroll_contribution_account_id'],
        'funding_replenishment_account_id': value['funding_replenishment_account_id'],
        'is_re_card_needed': value['is_re_card_needed'],
        'plans_to_reactivate': value['plans_to_reactivate'] == null ? undefined : ((value['plans_to_reactivate'] as Array<any>).map(IPlanToReactivateToJSON)),
    };
}

